import img20a from '../../../assets/gallery/20d/20d-01-HOME_ST-2020-1553x1335mm-oleo-sobre-tela.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "155,3 x 133,5 cm",
    pictureSrc: img20a,
    description: "2020",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];

export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/20d/data20d.js